module.exports = __webpack_public_path__ + "assets/img/sp3.c25676e1.jpg";